import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  BULK_OUTLET_LOG_SET_DATA,
  BULK_OUTLET_LOG_SET_ERRORS,
  BULK_OUTLET_LOG_SET_IS_LOADING,
  BULK_OUTLET_LOG_SET_SHOWN,
  BULK_OUTLET_SET_GLOBAL_ERROR,
  BULK_OUTLET_UPDATE_ABORT_PROCESS,
  BULK_OUTLET_UPDATE_CONFIRM_PROCESS_RESPOND,
  BULK_OUTLET_UPDATE_INITIALIZE_PROCESS_STATE,
  BULK_OUTLET_UPDATE_PREPEND_OUTLET_ERROR,
  BULK_OUTLET_UPDATE_SET_CURRENT_OUTLET_ID,
  BULK_OUTLET_UPDATE_SET_IS_PROCESSING,
  BULK_OUTLET_UPDATE_SET_PROCESS_STATUS,
  BULK_OUTLET_UPDATE_SET_PROCESSED_COUNT,
  BULK_OUTLET_UPDATE_SHOW_CONFIRM_PROCESS_MODAL,
} from 'state/actionTypes';
import ProcessStatus from 'constants/bulkAction/processStatus';

const isProcessing = createReducer(false, {
  [BULK_OUTLET_UPDATE_SET_IS_PROCESSING]: (state, { payload }) =>
    payload.isProcessing,
});

const processInitialState = {
  expirationDate: null,
  processed: 0,
  outletIds: [],
  errors: [],
  currentOutletId: null,
  status: null,
  cancelRequested: false,
  globalError: null,
};

const process = createReducer(processInitialState, {
  [BULK_OUTLET_UPDATE_INITIALIZE_PROCESS_STATE]: (
    state,
    { payload: { expirationDate, outletIds } }
  ) => ({
    expirationDate,
    processed: 0,
    outletIds,
    errors: [],
    currentOutletId: null,
    status: ProcessStatus.InProgress,
    cancelRequested: false,
    globalError: null,
  }),
  [BULK_OUTLET_UPDATE_SET_PROCESSED_COUNT]: (state, { payload }) => ({
    ...state,
    processed: payload.processed,
  }),
  [BULK_OUTLET_UPDATE_SET_CURRENT_OUTLET_ID]: (state, { payload }) => ({
    ...state,
    currentOutletId: payload.outletId,
  }),
  [BULK_OUTLET_UPDATE_SET_PROCESS_STATUS]: (state, { payload }) => ({
    ...state,
    status: payload.status,
  }),
  [BULK_OUTLET_UPDATE_PREPEND_OUTLET_ERROR]: (state, { payload }) => ({
    ...state,
    errors: [{ ...payload }, ...state.errors],
  }),
  [BULK_OUTLET_UPDATE_ABORT_PROCESS]: state => ({
    ...state,
    cancelRequested: true,
  }),
  [BULK_OUTLET_SET_GLOBAL_ERROR]: (state, { payload }) => ({
    ...state,
    globalError: payload.error,
  }),
});

const confirmModalShown = createReducer(false, {
  [BULK_OUTLET_UPDATE_SHOW_CONFIRM_PROCESS_MODAL]: () => true,
  [BULK_OUTLET_UPDATE_CONFIRM_PROCESS_RESPOND]: () => false,
});

const logModalInitialState = {
  shown: false,
  isLoading: false,
  data: [],
  paging: {
    page: 1,
    size: 20,
    total: 0,
  },
  errors: [],
};

const log = createReducer(logModalInitialState, {
  [BULK_OUTLET_LOG_SET_SHOWN]: (draft, { payload }) => {
    draft.shown = payload.shown;
  },
  [BULK_OUTLET_LOG_SET_DATA]: (draft, { payload }) => {
    draft.data = payload.data;
    draft.paging = payload.paging;
  },
  [BULK_OUTLET_LOG_SET_IS_LOADING]: (draft, { payload }) => {
    draft.isLoading = payload.isLoading;
  },
  [BULK_OUTLET_LOG_SET_ERRORS]: (draft, { payload }) => {
    draft.errors = payload.errors;
  },
});

export default combineReducers({
  isProcessing,
  process,
  confirmModalShown,
  log,
});
